export default "/images/vendor/flag-icons/flags/4x3/zm.svg?83315fdb0c0a837ccd6033761ed7437e";